import DateSelectView from "./components/DateSelectView";
import { SVGAsset } from "res";
import { useState, useEffect } from "react";
import { BCMSDate, BCMSValidate } from "@bcm-dev/bcms-vite";
/**
 * @function DateSelect 
 * @param {BCMSDate} value - an instance of BCMSDate
 * @param {allowPast} value - BOOL allow past dates dateLabel
 * @param {dateLabel} value - STRING for floating label
 * @param {BCMSDate} value - an instance of BCMSDate
 * @param {FUNCTION} onChange - (STRING -> VOID) function is called when date is selected.
 * @returns {React.Component}
 * @example
 * 
 *    let [dateValue,setDate] = useState(BCMSDate.init())
 *     let onChange =(date)=>{
 *        console.log(dateValue)
 *        setDate(()=>date)
 *     }
  ...           
        <DateSelect value={""} onChange={onChange}/>         
 */


export default function UIDatePicker(props) {

  /* creates a new state for the date select  */
  const dataPoint = props["data-point"] ?? "";
  const floatingLabelDataPoint = props["data-point"] ? { "data-point" : props["data-point"] + "_Floating_Label" } : {};
  let [calendarDate, setCalendar] = useState((props.value === undefined || props.value === "") ? BCMSDate.init() : props.value)
  let [inputDate, setInput] = useState(props.value ? props.value.format("M d, Y") : "");

  // Update the input state if the props.value has been updated
  useEffect(() => setInput(props.value ? props.value.format("M d, Y") : ""), [ props.value ]);

  let changeDate = (value) => {
    if (props.onChange !== undefined) {
      props.onChange(value)
    }
    setInput(value.format("M d, Y"));
    setCalendar(BCMSDate.init(value))
  }

  let use = (controllers) => {
    const showValue = (evt) => {
      /* if string from input is a valid date sets in as state for the date select     */
      /*open the date select*/     
      controllers.toggle();
    }

    let dateSelect = (event) => {
      if (BCMSValidate.isDate(event.target.value)) {
        setCalendar(BCMSDate.init(event.target.value));
        setInput(event.target.value);
      }
      else {
        setInput(event.target.value);
      }
    }

    let inputOnBlur = event => {
      // Listen to input changes along with calendar click changes.
      if(props.onChange !== undefined) {
        props.onChange(event.target.value);
      }
    }

   // const placeholder = props.placeholder ?? BCMSDate.init().format("M d, Y");
    return (
      <div className="date-label">
        <div className="input-container">
          <input className="flex-width" value={inputDate} onChange={dateSelect} onBlur={ inputOnBlur } data-point={dataPoint} placeholder=" " />
          <label className="floating-label form-row-label" { ...floatingLabelDataPoint }>{props.dateLabel}</label>
         <span onClick={showValue}> <SVGAsset id="CalendarIcon" className='icon calendar-icon clickable'  /></span>
        </div>
        <span className="form-row-info-text gray-text">
          {props.children}
        </span>
      </div>
    )
  }
  return <DateSelectView setDate={calendarDate} inputDate={inputDate} onChange={changeDate} use={use} allowPast={ props.allowPast } allowFuture={ props.allowFuture } />
}
